// Fluid pills size against the nearest FLUID_CELL_CLASS ancestor (a CSS size container).
export const FLUID_CELL_CLASS = 'w-full [container-type:inline-size]';
// Truncates first; once the cell can't show a few letters it goes icon-only, kept for screen readers.
export const FLUID_LABEL_CLASS = 'min-w-0 truncate [@container(max-width:67px)]:sr-only';
// Trims the solid pills' padding before their label has to truncate.
export const FLUID_PILL_TIGHT_CLASS =
    '[@container(max-width:127px)]:px-2 [@container(max-width:127px)]:gap-1';
